// Core
import { call, put } from 'redux-saga/effects';

// Instruments
import { hotActions as actions } from '../../actions';

export function* getToursCountriesWorker () {
    try {
        const response = yield call(fetch, '/api/countries/tours/modules', {
            headers: {
                'Authorization': 'Basic ZGV2OmRldg==',
            },
        });

        if (response.status !== 200) {
            throw new Error();
        }

        const countries = yield call([response, 'json']);

        yield put(actions.getToursCountriesSuccess(countries));
    } catch (error) {
        yield put(actions.getToursCountriesFail(error));
    }
}
